import { forwardRef, type InputHTMLAttributes } from "react";
import type { LucideIcon } from "lucide-react";
import { Input, Label } from "@bookdental/ui";
import { cn } from "@/lib/cn";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  icon: LucideIcon;
  label: string;
  htmlId: string;
  hint?: string;
};

/** Input com label pequena em cima, icone a esquerda dentro do campo. */
export const FieldWithIcon = forwardRef<HTMLInputElement, Props>(function FieldWithIcon(
  { icon: Icon, label, htmlId, hint, className, ...inputProps },
  ref,
) {
  return (
    <div className="space-y-1.5">
      <Label
        htmlFor={htmlId}
        className="text-[11px] font-medium uppercase tracking-wider text-zinc-500"
      >
        {label}
      </Label>
      <div className="relative">
        <Icon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-400" />
        <Input
          ref={ref}
          id={htmlId}
          className={cn("h-11 pl-9 transition-colors focus-visible:border-brand-400", className)}
          {...inputProps}
        />
      </div>
      {hint && <p className="text-[11px] text-zinc-500">{hint}</p>}
    </div>
  );
});
